import { Injectable } from "@angular/core";
import {BaseApiTemplateService, PagingResponseModel, ApiVisa} from '../../shared';
import {SpendingLimitAlarmContainerModel} from '../../../../../../models/aggregates/crm/spending-limit';
import {Core2Config} from '../../shared';
import {HttpClient} from '@angular/common/http';

@Injectable({
    providedIn: 'root'
  })
  export class SpendingLimitAlarmService extends BaseApiTemplateService<SpendingLimitAlarmContainerModel> {
    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'spending-limit-alarms';
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'spending-limit-alarms';
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CRM_PREFIX + 'spending-limit-alarms';
      this.httpClient = http;
    }
}